import React from 'react';
import './index.css';


/**
 * @param {number} score 0~5，5分制
 */
export default function (props) {
  let { className } = props;
  let score = props.score || 5;
  let fgCount = Math.ceil(score);
  let stars = [];

  let l; // 每颗星星占比
  for (let i = 1; i <= 5; i++) {
    l = i < fgCount ? 1 : i > fgCount ? 0 : (score - fgCount + 1);

    stars.push(
      <div className="star-score-single" key={i}>
        <i className="score-bg icon icon-star"></i>
        <i className="score-fg icon icon-star" style={{width: l + 'em'}}></i>
      </div>
    );
  }

  return (
    <div className={`star-score ${className}`}>
      {stars}
    </div>
  );
}





// WEBPACK FOOTER //
// ./src/components/StarScore/index.js